import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Box, List, ListItemButton} from 'views/components';

import _ from 'lodash';

const FilterOptions = (props) => {
  const {
    filter,
    onClick,
  } = props;

  const options = filter.options;

  if (_.isEmpty(options)) {
    return null;
  }

  const sortedFilter = Object.values(options).sort((a, b) => {
    const rankA = a.rank;
    const rankB = b.rank;

    // Both items have a rank, compare by rank
    if (rankA !== undefined && rankB !== undefined) {
      return rankA - rankB;
    }

    // Only one item has a rank
    if (rankA !== undefined) return -1;
    if (rankB !== undefined) return 1;

    // Neither item has a rank, maintain original order
    return 0;
  });

  return (
    <Box sx={{pointerEvents: 'auto', p: 1}}>
      <Box>
        <Typography sx={{fontWeight: 'bold'}}>
          {filter.label}
        </Typography>
        <List sx={{pb: 0}}>
          {
            sortedFilter.map((option, index) => {
              return (
                <ListItemButton key={index} onClick={() => onClick(filter, option)}>
                  {option.label}
                </ListItemButton>
              );
            })
          }
        </List>
      </Box>
    </Box>
  );
};
FilterOptions.propTypes = {
  filter: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default React.memo(FilterOptions);
